import React from 'react';
import { Row, Col } from 'react-bootstrap';

import I18n from 'i18n-react';

import './TypeOfFlight.css';

class TypeOfFlight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pointsIsChecked: false,
      nonStopChecked: props.typeOfFlight === 'D' ? true : false
    };
  }

  componentWillMount() {
    let isChecked = this.props.typeOfFlight === 'D' ? true : false;
    this.setState({ nonStopChecked: isChecked });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.typeOfFlight !== nextProps.typeOfFlight) {
      this.props.typeOfFlightCallback(nextProps.typeOfFlight);
      let isChecked = nextProps.typeOfFlight === 'D' ? true : false;
      this.setState({ nonStopChecked: isChecked });
    };
  }


  setNonStop() {
    let isChecked = !this.state.nonStopChecked
    this.setState({ nonStopChecked: isChecked });
    let typeOfFlight = isChecked === true ? 'D' : 'A';
    this.props.typeOfFlightCallback(typeOfFlight);
  }

  render() {
    return (
      <Row>
        <Col md={6} sm={6} xs={12}>
          <label className="control-label">{I18n.translate('typeOfFlight.ticketValueIn')}</label>
          <div className="radio-toggle-group">
            <div className="radio-toggle">
              <input type="radio"
                id="farePoints"
                name="fareTypes"
                value="farePoints"
                onChange={() => this.setState({ pointsIsChecked: true })}
                checked />
              <label htmlFor="farePoints">
                {I18n.translate('home.label.points')}
              </label>
            </div>
          </div>
        </Col>
        <Col md={6} sm={6} xs={12}>
          <div className="checkbox-toggle">
            <input type="checkbox"
              id="nonStop"
              name="nonStop"
              checked={this.state.nonStopChecked}
              onChange={() => { this.setNonStop() }} />
            <label htmlFor="nonStop">
              <i className="ta-icon"></i>
              <span>{I18n.translate('typeOfFlight.directFlightOnly')}</span>
            </label>
          </div>
        </Col>
      </Row>
    );
  }
}

export default TypeOfFlight;


// WEBPACK FOOTER //
// ./src/components/searchBox/typeOfFlight/TypeOfFlight.jsx